{
  "golf": {
    "moments": [
      {
        "id": "golf-featured",
        "title": "Golf Getaways",
        "description": "Exclusive Bonvoy Marriott Moments Golf Experiences",
        "image": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-golf-club-next-to-teed-go-14312?wid=632&fit=constrain",
        "href": "https://moments.marriottbonvoy.com/en-us/search?KeywordBox=golf"
      }
    ]
  },
  "ski": {
    "moments": [
      {
        "id": "ski-featured",
        "title": "The Snow League LAAX",
        "description": "Attend The Snow League Competition and an unforgettable mountain experience with Olympic legend, Shaun White",
        "image": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-gettyimages-690866593-36392?wid=316&fit=constrain",
        "href": "https://moments.marriottbonvoy.com/en-us/moments/collection/1131"
      }
    ]
  },
  "beach": {
    "moments": [
      {
        "id": "beach-featured",
        "title": "Beach Adventures are Calling",
        "description": "Marriott Bonvoy Outdoors is your path to unforgettable experiences",
        "image": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-tahiti-beach-33905?wid=316&fit=constrain",
        "href": "https://moments.marriottbonvoy.com/en-us/moments/collection/1084"
      }
    ]
  },
  "spa": {
    "moments": [
      {
        "id": "spa-featured",
        "title": "Retreats and Other Unique Wellness Experiences",
        "description": "Experience luxurious wellness rituals",
        "image": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-relaxing-massage-42358-58457?wid=632&fit=constrain",
        "href": "https://moments.marriottbonvoy.com/en-us/moments/category/arts-lifestyle/search?SubCategories=100011"
      }
    ]
  },
  "culinary": {
    "moments": [
      {
        "id": "culinary-featured",
        "title": "Stay, Savor, and Discover Vietnams Culinary Soul",
        "description": "Exclusive Ngon Series Experience with Ngon Masters, Multiple Locations",
        "image": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-seoul-dining-12684?wid=632&fit=constrain",
        "href": "https://moments.marriottbonvoy.com/en-us/moments/collection/1111"
      }
    ]
  },
  "culture": {
    "moments": [
      {
        "id": "culture-featured",
        "title": "Arts & Lifestyle",
        "description": "Attend premieres, galas, cultural excursions, and exclusive events.",
        "image": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-gettyimages-1432866467-14974?wid=632&fit=constrain",
        "href": "https://moments.marriottbonvoy.com/en-us/moments/category/arts-lifestyle"
      }
    ]
  },
  "music": {
    "moments": [
      {
        "id": "music-featured",
        "title": "Entertainment",
        "description": "Get show-stopping access to epic concerts, music festivals, and more.",
        "image": "https://cache.marriott.com/is/image/marriotts7prod/bonvoy-gettyimages-1946109745-32520?wid=632&fit=constrain",
        "href": "https://moments.marriottbonvoy.com/en-us/moments/category/entertainment"
      }
    ]
  }
}